module.exports = __webpack_public_path__ + "img/predictive_dashboard2.108c5c2e.png";